import Swiper from 'swiper';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {
	const carousels = document.querySelectorAll('.carousel');

	if (carousels.length) {
		carousels.forEach((carousel) => {
			const paginationEl = carousel.querySelector('.carousel-pagination');
			const swiperEl = carousel.querySelector('.carousel-swiper');
			const slides = carousel.querySelectorAll('.swiper-slide');

			new Swiper(swiperEl, {
				autoplay: slides.length > 1 ? {
					//disableOnInteraction: true,
					pauseOnMouseEnter: true,
					delay: 6000,
				} : false,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				loop: slides.length > 1,
				modules: [Autoplay, EffectFade, Pagination],
				pagination: {
					clickable: true,
					el: paginationEl,
				},
				speed: 700,
			});
		});
	}
});
